
import MeaPage from "../../../components/MeaPage";
import { useLoaderData, useParams, useRevalidator } from "react-router-dom";
import trainingsAPI from "../../../services/trainings";
import { Calendar } from "primereact/calendar";
import { Editor } from "primereact/editor";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import RegistrationPreviewPage from "../preview/RegistrationPreviewPage";

const RegistrationSettingsPage = () => {
  const { registration } = useLoaderData();
  const revalidator = useRevalidator();
  //
  const [registrationStartDate, setRegistrationStartDate] = useState("");
  const [registrationEndDate, setRegistrationEndDate] = useState("");
  const [registrationMessage, setRegistrationMessage] = useState("");
  const [allowNewRegistrations, setAllowNewRegistrations] = useState(false);
  const [allowEditingInformations, setAllowEditingInformations] = useState(true);
  const [allowEditingStudentPhotos, setAllowEditingStudentPhotos] = useState(true);
  const [showLastResult, setShowLastResult] = useState(false);
  const [showNewAffectation, setShowNewAffectation] = useState(false);
  const [allowPayments, setAllowPayments] = useState(true);
  const [allowFamilySlotChangeRequests, setAllowFamilySlotChangeRequests] = useState(false);
  //
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  //
  const params = useParams();
  const schoolId = params.schoolId
  const registrationId = params.registrationId;
  const accessToken = "";
  //
  useEffect(() => {
    setRegistrationStartDate(registration?.start_registration_date || "");
    setRegistrationEndDate(registration?.end_registration_date || "");
    setRegistrationMessage(registration?.registration_message || "");
    setAllowNewRegistrations(registration?.registration_allow_new || false);
    setAllowEditingInformations(registration?.registration_allow_edit_informations !== false);
    setAllowEditingStudentPhotos(registration?.registration_allow_edit_student_photos !== false);
    setShowLastResult(registration?.registration_show_last_result || false);
    setShowNewAffectation(registration?.registration_show_new_affectation || false);
    setAllowPayments(registration?.registration_allow_payments !== false);
    setAllowFamilySlotChangeRequests(registration?.registration_allow_slot_change_requests || false);
  }, [registration]);

  const handleSaveRegistrationDates = () => {
    // Handle update action
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          start_registration_date:
            registrationStartDate !== "" && registrationStartDate !== undefined
              ? new Date(registrationStartDate).toISOString()
              : null,
          end_registration_date:
            registrationEndDate !== "" && registrationStartDate !== registrationEndDate
              ? new Date(registrationEndDate).toISOString()
              : null,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleCancelRegistrationDates = () => {
    setRegistrationStartDate(registration?.start_registration_date || "");
    setRegistrationEndDate(registration?.end_registration_date || "");
  }

  const handleSaveMessage = () => {
    // Handle update action
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_message: registrationMessage,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveAllowNewRegistrations = (value) => {
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_allow_new: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveShowLastResult = (value) => {

    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_show_last_result: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveAllowEditingInformations = (value) => {
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_allow_edit_informations: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveAllowEditingStudentPhotos = (value) => {
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_allow_edit_student_photos: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveShowNewAffectation = (value) => {

    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_show_new_affectation: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveAllowPayments = (value) => {
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_allow_payments: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveAllowFamilySlotChangeRequests = (value) => {
    setLoading(true);
    trainingsAPI
      .UpdateOne(schoolId, registrationId, accessToken, registrationId,
        {
          registration_allow_slot_change_requests: value,
        })
      .then((data) => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          life: 1000,
          detail: "Modification effectuée avec succès!",
        });
        revalidator.revalidate();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleCancelMessage = () => {
    setRegistrationMessage(registration?.registration_message || "");
  }

  const [previewDialogVisible, setPreviewDialogVisible] = useState(false);

  const showPreviewDialog = () => {
    setPreviewDialogVisible(true);
  }

  const hidePreviewDialog = () => {
    setPreviewDialogVisible(false);
  }

  return (
    <>
      <MeaPage title="Gestion de l'espace famille" showBackButton={false}>
        <Toast ref={toast} position="bottom-center" />
        <Dialog
          visible={previewDialogVisible}
          onHide={hidePreviewDialog}
          maximizable
          modal
          style={{ width: '90vw', height: '90vh' }}
          header="Aperçu de la page d'inscription"
          footer={<Button label="Fermer" icon="pi pi-times" onClick={hidePreviewDialog} />}
          contentStyle={{ backgroundColor: 'var(--mea-background-color)' }}
        >
          <div className="flex flex-column h-full" >
            <div className="flex-grow-1" >
              <RegistrationPreviewPage />
            </div>

          </div>
        </Dialog>
        <div className="card surface-section p-3">
          <div className="grid">

            <div className="col-12">
              <div className="field">
                <label htmlFor="campaignStartDate" className="w-12rem pr-3">Date de début des inscriptions</label>
                <Calendar locale="fr" value={registrationStartDate !== "" ? new Date(registrationStartDate) : ""} onChange={(e) => {
                  setRegistrationStartDate(e.value || "")

                }} dateFormat="dd/mm/yy" id="registration_start" showIcon />
              </div>
            </div>
            <div className="col-12">
              <div className="field">
                <label htmlFor="campaignEndDate" className="w-12rem pr-3">Date de fin des inscriptions</label>
                <Calendar locale="fr" value={registrationEndDate ? new Date(registrationEndDate) : ""}
                  onChange={(e) => setRegistrationEndDate(e.value)} dateFormat="dd/mm/yy" id="registration_end" showIcon />
              </div>
              <div className="flex justify-content-end mt-2">
                <Button
                  className="mr-2"
                  onClick={handleSaveRegistrationDates}
                  loading={loading}
                >
                  Enregistrer
                </Button>
                <Button outlined onClick={handleCancelRegistrationDates}>
                  Annuler
                </Button>
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="mailMessage" className=" pr-3">Message personnalisé de l'espace famille</label>
                <small className="block text-gray-600 mb-2">Ce texte sera affiché dans l'espace famille par les parents. Il pourra être utilisé dans les mails de campagne.</small>
                <Editor
                  id="mailMessage"
                  value={registrationMessage}
                  onTextChange={(e) => {
                    setRegistrationMessage(e.htmlValue)
                  }}
                  style={{ height: '200px' }}
                />
              </div>
            </div>

            <div className="col-12 flex justify-content-between gap-2">
              <Button outlined onClick={showPreviewDialog}>
                Aperçu
              </Button>
              <div className="flex gap-2">
                <Button loading={loading} className="p-button p-button-primary" onClick={handleSaveMessage}>
                  Enregistrer
                </Button>
                <Button outlined onClick={handleCancelMessage}>
                  Annuler
                </Button>
              </div>

            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="allowNewRegistrations" className="w-12rem pr-3">Autoriser les nouvelles inscriptions</label>
                <InputSwitch
                  inputId="allowNewRegistrations"
                  checked={allowNewRegistrations}
                  onChange={(e) => {
                    setAllowNewRegistrations(e.value);
                    handleSaveAllowNewRegistrations(e.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="showLastResult" className="w-12rem pr-3">Afficher le dernier résultat dans l'espace famille</label>
                <InputSwitch
                  inputId="showLastResult"
                  checked={showLastResult}
                  onChange={(e) => {
                    setShowLastResult(e.value);
                    handleSaveShowLastResult(e.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="allowEditingInformations" className="w-12rem pr-3">Autoriser la modification des informations (parents et élèves)</label>
                <InputSwitch
                  inputId="allowEditingInformations"
                  checked={allowEditingInformations}
                  onChange={(e) => {
                    setAllowEditingInformations(e.value);
                    handleSaveAllowEditingInformations(e.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="allowEditingStudentPhotos" className="w-12rem pr-3">Autoriser la modification des photos des élèves</label>
                <InputSwitch
                  inputId="allowEditingStudentPhotos"
                  checked={allowEditingStudentPhotos}
                  onChange={(e) => {
                    setAllowEditingStudentPhotos(e.value);
                    handleSaveAllowEditingStudentPhotos(e.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="showNewAffectation" className="w-12rem pr-3">Afficher la nouvelle affectation dans l'espace famille</label>
                <InputSwitch
                  inputId="showNewAffectation"
                  checked={showNewAffectation}
                  onChange={(e) => {
                    setShowNewAffectation(e.value);
                    handleSaveShowNewAffectation(e.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="allowPayments" className="w-12rem pr-3">Autoriser le paiement des cotisations</label>
                <InputSwitch
                  inputId="allowPayments"
                  checked={allowPayments}
                  onChange={(e) => {
                    setAllowPayments(e.value);
                    handleSaveAllowPayments(e.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12" style={{ borderTop: "1px solid #ccc", paddingTop: "1rem" }}>
              <div className="field">
                <label htmlFor="allowFamilySlotChangeRequests" className="w-12rem pr-3">Autoriser les demandes de changement de créneau dans l'espace famille</label>
                <InputSwitch
                  inputId="allowFamilySlotChangeRequests"
                  checked={allowFamilySlotChangeRequests}
                  onChange={(e) => {
                    setAllowFamilySlotChangeRequests(e.value);
                    handleSaveAllowFamilySlotChangeRequests(e.value);
                  }}
                />
              </div>
            </div>

            {/* <div className="col-12">
              <div className="field">
                <label className="pr-3">Aperçu du message</label>
                <div className="border-1 surface-border border-round p-3 " dangerouslySetInnerHTML={{ __html: registrationMessage }}></div>
              </div>
            </div> */}
          </div>
        </div>

      </MeaPage>
    </>
  );
};
export default RegistrationSettingsPage;
